import types from './actionTypes';

export function setMenuType(menuType) {
  return { type: types.SET_MENU_TYPE, menuType };
}

export function setMenu(menu) {
  return { type: types.SET_MENU, menu };
}
